import { loadScript } from '../utils/dom/loadScript';

const loadPolyfills = async () => {
    const promises = [];

    if (!Object.groupBy) promises.push(import('core-js/features/object/group-by'));
    if (!Object.hasOwn) promises.push(import('core-js/features/object/has-own'));
    if (!Array.prototype.at) promises.push(import('core-js/features/array/at'));

    await Promise.all(promises);
};

export default defineNuxtPlugin(async (nuxtApp) => {
    console.debug('[Client-scripts]: Init.');

    try {
        await loadPolyfills();
    } catch (e) {
        console.error('[Script Loader] Failed to load polyfills:', e);
    }

    try {
        /** Ensure Matomo queue exists */
        window._paq = window._paq || [];

        /** Ensure fbq stub exists first */
        window.fbq = window.fbq || function () {
            (window.fbq.queue = window.fbq.queue || []).push(arguments);
        };
        window._fbq = window.fbq;

        /** Initialize the dataLayer variable */
        window.dataLayer = window.dataLayer || [];

        const host = window.location.hostname;
        const scripts = [
            {
                src: `https://consent.studio/${host === 'localhost' ? 'staging.zooingvar.com' : host}/banner.js`,
                async: false,
                defer: true
            },
        ];

        scripts.map(({ src, ...options }) => loadScript(src, options));

        // Adding events to log consents in Matomo.
        [{ event: 'analytics', actions: ['granted', 'denied'] }, { event: 'marketing', actions: ['granted', 'denied'] }]
            .forEach(({ event, actions }) => actions.forEach((action) => {
                window.addEventListener(`consent-studio__updated__${action}__${event}`, () => {
                    var matomo = useMatomo();

                    console.debug(`[Client-scripts] Consent Studio ${event} consent ${action}.`);

                    matomo.trackEvent('Consent', `${event}: ${action}`);
                });
            }));
    } catch (e) {
        console.error('[Script Loader] Failed to load scripts:', e);
    }
});